import { useEffect, useState } from 'react'
import { useI18n } from '../../i18n'
import { missionCopy } from '../missionCopy'

const topics = ['race', 'checkpoint', 'stats'] as const
type Topic = typeof topics[number]
const keyFor = (topic: Topic) => `leveleria.help.${topic}.hidden`
const resetEvent = 'leveleria:help-reset'

export const resetHelpTips = () => {
  try { topics.forEach((topic) => localStorage.removeItem(keyFor(topic))) } catch { /* Help still resets for this session. */ }
  window.dispatchEvent(new Event(resetEvent))
}

export const InlineHelp = ({ topic, text }: { topic: Topic; text: string }) => {
  const { language } = useI18n()
  const c = missionCopy[language]
  const [hidden, setHidden] = useState(() => { try { return localStorage.getItem(keyFor(topic)) === 'true' } catch { return false } })
  useEffect(() => {
    const reset = () => setHidden(false)
    window.addEventListener(resetEvent, reset)
    return () => window.removeEventListener(resetEvent, reset)
  }, [])
  const toggle = () => {
    const next = !hidden
    setHidden(next)
    try { localStorage.setItem(keyFor(topic), String(next)) } catch { /* Keep the current session preference. */ }
  }
  return <button className={`inline-help${hidden ? ' inline-help--collapsed' : ''}`} type="button" aria-expanded={!hidden} aria-label={hidden ? `${c.showHelp}: ${text}` : `${c.hideHelp}: ${text}`} title={hidden ? text : c.hideHelp} onClick={toggle}>{hidden ? <span aria-hidden="true">ⓘ</span> : <><span>{text}</span><small>{c.dismissHint}</small></>}</button>
}
